'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "semanticColor", "paddingBottom", "variant", "weight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { TypeElement, weights } from "./Type.mjs";
var TypeComponent = /*#__PURE__*/React.forwardRef(function TypeComponent(_ref, ref) {
  var color = _ref.color,
    semanticColor = _ref.semanticColor,
    paddingBottom = _ref.paddingBottom,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'viola' : _ref$variant,
    weight = _ref.weight,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TypeElement, Object.assign({
    $variant: variant,
    $semanticColor: semanticColor,
    $paddingBottom: paddingBottom,
    $weight: weight,
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.Type
  }));
});

// export components
export var elements = {
  /**
   * @deprecated
   * Use `<Type as="h1" />` instead.
   */
  h1: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h1",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h2" />` instead.
   */
  h2: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h2",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h3" />` instead.
   */
  h3: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h3",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h4" />` instead.
   */
  h4: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h4",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h5" />` instead.
   */
  h5: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h5",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="h6" />` instead.
   */
  h6: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "h6",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="p" />` instead.
   */
  p: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "p",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="small" />` instead.
   */
  small: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "small",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type as="li" />` instead.
   */
  li: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "li",
      ref: ref
    }, props));
  }),
  /**
   * @deprecated
   * Use `<Type />` instead (span is the default element).
   */
  span: /*#__PURE__*/React.forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(TypeComponent, Object.assign({
      as: "span",
      ref: ref
    }, props));
  })
};
var typeHelpers = _objectSpread(_objectSpread({}, elements), weights);
export var Type = Object.assign(TypeComponent, typeHelpers);